import React from 'react';
import cx from 'classnames';
import Card from "@scentregroup/ui/components/card";
import Heading from "@scentregroup/ui/components/heading";
import { SubLabel } from '@scentregroup/ui/components/form/label';
import { FieldSize } from '@scentregroup/ui/components/form/fieldsize';
import { CardColor } from '@scentregroup/ui/components/card';
import { HeadingSize } from '@scentregroup/ui/components/heading';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const HeaderElement = _ref => {
  let {
    heading,
    subLabel,
    rightElement
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: cx({
        [style.rightElement]: rightElement
      }),
      "data-id": "order-card_index_HeaderElement_div",
      children: [/*#__PURE__*/_jsx(Heading, {
        type: HeadingSize.small,
        "data-id": "order-card_index_HeaderElement_div_Heading",
        children: heading
      }), rightElement]
    }), subLabel && /*#__PURE__*/_jsx("div", {
      className: style.headingSubLabel,
      "data-id": "order-card_index_HeaderElement_div",
      children: /*#__PURE__*/_jsx(SubLabel, {
        size: FieldSize.SMALL,
        "data-id": "order-card_index_HeaderElement_div_SubLabel",
        children: subLabel
      })
    })]
  });
};

const OrderCard = _ref2 => {
  let {
    wrapperClassName,
    className,
    heading,
    subHeading,
    headerElement,
    children,
    childWrapperClassName,
    headerUnderline = true
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: wrapperClassName,
    "data-id": "order-card_index_HeaderElement_div",
    children: /*#__PURE__*/_jsx(Card, {
      heading: heading,
      subHeading: subHeading,
      headingProps: {
        type: HeadingSize.small
      },
      headerElement: headerElement && /*#__PURE__*/_jsx(HeaderElement, {
        heading: headerElement.heading,
        subLabel: headerElement === null || headerElement === void 0 ? void 0 : headerElement.subLabel,
        rightElement: headerElement === null || headerElement === void 0 ? void 0 : headerElement.rightElement,
        "data-id": "order-card_index_HeaderElement"
      }),
      cardColor: CardColor.none,
      headerUnderline: Boolean(heading) && headerUnderline,
      cardPadding: false,
      className: className,
      "data-id": "order-card_index_HeaderElement_div_Card",
      children: /*#__PURE__*/_jsx("div", {
        className: cx(childWrapperClassName, {
          [style.topMargin]: !headerUnderline
        }),
        "data-id": "order-card_index_HeaderElement_Card_div",
        children: children
      })
    })
  });
};

export default OrderCard;